import axios from 'axios';

const API_URL = '/api/permissions'; // Adjust based on your actual API route

export const getPermissions = async () => {
    try {
        const response = await axios.get(`${API_URL}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching permissions', error);
        throw error;
    }
};